import GLightbox from "glightbox";
export default function () {
    const elements = document.querySelectorAll(".gallery-item");
    if (elements.length) {
        GLightbox({
            selector: ".gallery-item",
            skin: "aircraft-gallery",
        });
    }

    const video = document.querySelectorAll(".js-open-video-popup-wistia");
    
    if (video.length > 0) {
        for(var x=0;x<video.length;x++){
            video[x].setAttribute('id','wistia-video-' + (x + 1));

            GLightbox({
                touchNavigation: false,
                loop: false,
                autoplayVideos: true,
                selector: '#' + video[x].getAttribute('id'),
            })
        }
    }

    const videoNormal = document.querySelector(".js-open-iframe-popup");
    if (videoNormal) {
        GLightbox({
            touchNavigation: false,
            loop: false,
            autoplayVideos: true,
            selector: ".js-open-iframe-popup",
        });
    }

    const tmSingleElements = document.querySelectorAll(".tm-single");

    if (tmSingleElements.length > 0) {
        tmSingleElements.forEach((tmSingle, index) => {
            tmSingle.addEventListener("click", function () {
                const teamMemberPopup = tmSingle.querySelector(".js-team");

                if (teamMemberPopup) {
                    const lightboxContent = [];

                    tmSingleElements.forEach((tm, i) => {
                        const contentContainer = document.createElement("div");
                        contentContainer.innerHTML =
                            tm.querySelector(".js-team").innerHTML;
                        lightboxContent.push({
                            content: contentContainer.innerHTML,
                        });

                        // If the current team member is the clicked one, set its index as the starting index
                        if (tmSingle === tmSingleElements[i]) {
                            index = i;
                        }
                    });
                    
                    const lightBox = GLightbox({
                        elements: lightboxContent,
                        touchNavigation: true,
                        loop: true,
                        autoplayVideos: true,
                        startAt: index,
                        slideEffect: "fade",
                    });
                    lightBox.open();
                }
            });
        });
    }
}
